var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalBatches(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    enableBackground: "new 0 0 50 50",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#F39440",
    cx: 25,
    cy: 24.999,
    r: 24.211
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M26.255,26.54l-2.227-0.982l0.375-0.849l1.376,0.608l0.607-1.377l0.851,0.375L26.255,26.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M16.543,29.774l-0.85-0.375l0.982-2.227l2.227,0.982l-0.375,0.85l-1.377-0.608L16.543,29.774z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M25.558,26.021c-0.396-1.945-2.108-3.342-4.093-3.342s-3.696,1.396-4.093,3.342l-0.91-0.186 c0.484-2.379,2.576-4.088,5.003-4.088c2.428,0,4.519,1.709,5.004,4.088L25.558,26.021z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M21.465,31.963c-2.425-0.006-4.513-1.71-5.003-4.085l0.91-0.186c0.397,1.944,2.108,3.341,4.093,3.341 s3.696-1.396,4.093-3.341l0.911,0.186C25.979,30.253,23.89,31.957,21.465,31.963z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M14.967,23.144h-0.929v-2.785h2.785v0.928h-1.856V23.144z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M11.253,35.212h2.785v0.929h-2.785V35.212z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M19.608,10.146v2.785h-2.785v2.785h-2.785v2.785h-1.856v14.854H9.396v3.713 c0.001,1.538,1.247,2.783,2.785,2.785h15.781c1.538-0.002,2.784-1.247,2.785-2.785V18.501H14.967v-1.856h17.639v16.71h0.928V15.717 H17.751V13.86h17.639v16.71h0.928V12.932H20.537v-1.857h17.638v16.71h0.929V10.146H19.608z M12.182,38.925 c-1.026,0-1.857-0.831-1.857-1.856v-2.785h14.854v2.785c-0.001,0.686,0.252,1.347,0.71,1.856H12.182z M29.82,19.43v17.639 c0,1.025-0.832,1.856-1.857,1.856c-1.024,0-1.856-0.831-1.856-1.856v-3.713H13.11V19.43H29.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M38.175,29.642h0.929v2.785h-0.929V29.642z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M35.391,32.427h0.928v2.785h-0.928V32.427z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M32.605,35.212h0.928v2.785h-0.928V35.212z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalBatches);
export default __webpack_public_path__ + "static/media/TotalBatches.230d1b2cb9906f14b2853676f4e2b308.svg";
export { ForwardRef as ReactComponent };